














































































import { computed, defineComponent, inject, nextTick, reactive, ref } from '@vue/composition-api'
import AnalyzePoll from '@/components/form-common-analyze/AnalyzePoll.vue'
import AnalyzeConceptPoll from '@/components/form-common-analyze/AnalyzeConceptPoll.vue'
import { Divider } from 'element-ui'
import TextCheckbox from './components/TextCheckbox.vue'
import ImageCheckbox from './components/ImageCheckbox.vue'
import { EntityType, ProjectStatus } from '@/api/project/model'
import CalculateTime from '@/components/CalculateTime.vue'
import { storeToRefs } from 'pinia'
import { useProjectStore } from '@/pinia/modules/project'

export default defineComponent({
    components: {[Divider.name]: Divider, TextCheckbox, ImageCheckbox, AnalyzePoll, CalculateTime ,AnalyzeConceptPoll},
    props: {
        item: {
            type: Object
        }
    },
    setup(props, { root, emit }) {
        const head = inject('head')
        const conversationObj: any = inject('conversationObj')
        const observer: boolean = inject('observer', false)
        const { projectInfo } = storeToRefs(useProjectStore())
        const drawerInfo = reactive({
            isAnalyze: false,
            showDrawer: false,
            isAnalyzeConcept: false,
            showDrawerConcept: false,
            onOpen: () => {
                if(props.item?.message.test_group){
                    drawerInfo.isAnalyzeConcept = true
                    nextTick(() => {
                        drawerInfo.showDrawerConcept = true
                    })
                }else{
                    drawerInfo.isAnalyze = true
                    nextTick(() => {
                        drawerInfo.showDrawer = true
                    })
                }
               
            },
            onClose: () => {
                if(props.item?.message.test_group){
                    drawerInfo.showDrawerConcept = false
                    nextTick(() => {
                        drawerInfo.isAnalyzeConcept = false
                    })
                }else{
                    drawerInfo.showDrawer = false
                    nextTick(() => {
                        drawerInfo.isAnalyze = false
                    })
                }
               
            }
        })

        const participants = computed(() => {
            if (props.item?.collection) {
                return props.item.collection.result.participants
            }
            return 0
        })

        const showBranch = computed(() => {
            return (
                !observer &&
                [EntityType.poll, EntityType.picture_poll].includes(props.item?.message?.message_type) &&
                // !conversationObj.hasBranchIds.includes( props.item?.message?.message_entity_id ) &&
                projectInfo.value.status != ProjectStatus.End
            )
        })

        const isMult = computed(() => {
            return [EntityType.poll_multi, EntityType.picture_poll_multi].includes(props.item?.message?.message_type)
        })


        const liveObj: any = inject('liveObj')
        const time = computed(() => {
            let remain = 0
            // if (liveObj?.timeInfo?.message_entity_id == props.item?.message?.message_entity_id) {
            //     remain = liveObj?.timeInfo?.timeRemain
            // }
            if (liveObj?.timeInfo?.id == props.item?.message?.id&&liveObj?.timeInfo?.message_entity_id == props.item?.message?.message_entity_id) {
                return remain = liveObj?.timeInfo?.timeRemain
            }
            return remain
        })

        const createBranch = () => {
            emit(`createBranch`, props.item?.message)
        }

        return {
            head,
            participants,
            EntityType,
            showBranch,
            isMult,
            liveObj,
            time,
            createBranch,
            drawerInfo
        }
    }
})
